/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsEfsDefaultFormat
 */
export interface EfsMelcoEfsModelsEfsDefaultFormat {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsEfsDefaultFormat
     */
    service_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsEfsDefaultFormat
     */
    extension?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsEfsDefaultFormat
     */
    desc?: string | null;
}

export function EfsMelcoEfsModelsEfsDefaultFormatFromJSON(json: any): EfsMelcoEfsModelsEfsDefaultFormat {
    return EfsMelcoEfsModelsEfsDefaultFormatFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsEfsDefaultFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsEfsDefaultFormat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'service_type': !exists(json, 'service_type') ? undefined : json['service_type'],
        'extension': !exists(json, 'extension') ? undefined : json['extension'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
    };
}

export function EfsMelcoEfsModelsEfsDefaultFormatToJSON(value?: EfsMelcoEfsModelsEfsDefaultFormat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'service_type': value.service_type,
        'extension': value.extension,
        'desc': value.desc,
    };
}


